import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {

  constructor(private http: HttpClient) {
  }

  uploadFile(file: File): Observable<any> {
    const formData: any = new FormData();
    // Handle special case : eml file => transform to simple text file
    // mimetype = message/rfc822
    if (file.type === 'message/rfc822') {
      file = new File([file], file.name + '.txt');
    }
    const file_ = new File([file], encodeURIComponent(file.name), {type: file.type});

    formData.append('file', file_);
    formData.append('filename', file.name);
    formData.append('mimetype', file_.type);

    return this.http.post(`${environment.backendBase}/v1/tickets/upload-file`, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }
}
